import { useEffect } from "react";

import HomeSections from "../../../molecules/Desktop/HomePage/HomeSections";

const HomePage = () => {
  useEffect(() => {
    document.title = `HomeCook`;
  }, []);

  return <HomeSections />;
};

export default HomePage;
